module.exports = __webpack_public_path__ + "static/assets/14c2ce948d7d5bb1bbc752b86a093496.svg";